import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_app_bar, {
      color: "primary",
      height: "40px",
      elevation: "2",
      app: "",
      style: _normalizeStyle(_ctx.isOverlayVisible ? 'background-color: rgba(0,0,0,0.5) !important; filter: brightness(0.5);' : '')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tooltip, { bottom: "" }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps({
              to: "/attendance/list",
              text: "",
              color: "transparent",
              size: "default"
            }, props), {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { color: "white" }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-home", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 16)
          ]),
          default: _withCtx(() => [
            _cache[1] || (_cache[1] = _createElementVNode("span", null, "ホーム画面", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_menu, {
          "offset-y": "",
          transition: "slide-y-transition",
          "max-height": "80vh"
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps({
              class: "pr-0",
              dark: "",
              text: "",
              rounded: "",
              size: "small"
            }, props, {
              disabled: !_ctx.currentNurseryName
            }), {
              default: _withCtx(() => [
                _createElementVNode("strong", null, _toDisplayString(_ctx.currentNurseryName), 1),
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("mdi-menu-down", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 16, ["disabled"])
          ]),
          default: _withCtx(() => [
            (_ctx.me)
              ? (_openBlock(), _createBlock(_component_v_list, {
                  key: 0,
                  density: "compact",
                  "min-height": "400",
                  "max-height": "600",
                  class: "overflow-y-auto"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.me.nurserySchools, (item) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: item.nurseryId,
                        link: "",
                        onClick: ($event: any) => (_ctx.setNurseryId(item.nurseryId)),
                        class: _normalizeClass(item.nurseryId == _ctx.nurseryId ? 'text-primary font-weight-bold' : '')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.nurseryName), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "class"]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _cache[9] || (_cache[9] = _createElementVNode("h5", { class: "px-4 text-white" }, "|", -1)),
        _createVNode(_component_v_menu, {
          "offset-y": "",
          transition: "slide-y-transition"
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps({
              color: "white",
              size: "small",
              rounded: "",
              variant: "flat"
            }, props, {
              disabled: !_ctx.username
            }), {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "primary",
                  start: ""
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("mdi-account-circle", -1)
                  ]))]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.username), 1)
              ]),
              _: 1
            }, 16, ["disabled"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, { density: "compact" }, {
              default: _withCtx(() => [
                (_ctx.me)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 0,
                      class: "pb-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, { class: "text-grey" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.me.email), 1),
                            _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                            _cache[5] || (_cache[5] = _createTextVNode(" でログイン中 ", -1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_list_item, {
                  to: "/logout",
                  link: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("ログアウト", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_tooltip, { bottom: "" }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps({
              to: "/logout",
              class: "pl-4",
              text: "",
              color: "transparent",
              size: "default"
            }, props), {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { color: "white" }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("mdi-logout", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 16)
          ]),
          default: _withCtx(() => [
            _cache[8] || (_cache[8] = _createElementVNode("span", null, "ログアウト", -1))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["style"])
  ]))
}